import type { ReactNode } from 'react'

export interface DataItem {
  label: string
  /**
   * The value. `undefined` means the RDW does not publish it, and the row is dropped entirely —
   * an empty row is worse than no row, because it reads as "we looked and there is nothing there".
   */
  value?: ReactNode
  /**
   * Part of the paid tier. Set by `markPremium`, never by hand, so the whole premium split stays
   * readable in one file — and only ever changes how the row looks, never whether it is shown.
   */
  premium?: boolean
  /**
   * The value is a sentence rather than a figure. On a phone it moves under its label at full
   * width and in normal weight: the value column there is about 200px, and a paragraph set bold in
   * it runs to a dozen lines.
   */
  prose?: boolean
}

/**
 * Builds a list of rows, dropping every one whose value is absent.
 *
 * Written as a helper rather than as filtering inside the component so a caller can ask
 * `rows.length === 0` and skip the whole section — which is how a report for a 1970s Beetle avoids
 * six empty cards about WLTP figures.
 */
export function rows(...items: DataItem[]): DataItem[] {
  return items.filter((item) => item.value !== undefined && item.value !== null && item.value !== '')
}
